import React from "react";
import { Moon, Sun, Monitor } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";

/**
 * ThemeToggle — cicla entre modo claro, oscuro y sistema.
 * Persiste automáticamente vía next-themes (localStorage).
 */
export default function ThemeToggle({ compact = false }) {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => setMounted(true), []);
  if (!mounted) {
    return (
      <Button
        variant="outline"
        className={compact ? "w-9 h-9 p-0" : "w-full justify-start text-sm"}
        disabled
        aria-hidden="true"
      >
        <Sun className="w-4 h-4" />
      </Button>
    );
  }

  const current = theme === "system" ? "system" : (theme || resolvedTheme || "light");
  // Ciclo: system → dark → light → system.  Esto garantiza que el primer clic
  // desde "system" (usualmente = claro) ya muestre un cambio visible.
  const next = current === "system" ? "dark" : current === "dark" ? "light" : "system";
  const Icon = current === "light" ? Sun : current === "dark" ? Moon : Monitor;
  const label = current === "light" ? "Claro" : current === "dark" ? "Oscuro" : "Sistema";
  const nextLabel = next === "light" ? "Claro" : next === "dark" ? "Oscuro" : "Sistema";
  const tooltip = `Modo actual: ${label}. Click para: ${nextLabel}`;

  if (compact) {
    return (
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setTheme(next)}
        title={tooltip}
        data-testid="theme-toggle"
        aria-label={tooltip}
      >
        <Icon className="w-4 h-4" />
      </Button>
    );
  }

  return (
    <Button
      variant="outline"
      className="w-full justify-start text-sm"
      onClick={() => setTheme(next)}
      title={tooltip}
      data-testid="theme-toggle"
    >
      <Icon className="w-4 h-4 mr-2" />
      Tema: {label}
    </Button>
  );
}
